import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaTimes, FaSpinner, FaCheckCircle } from "react-icons/fa";

function ContactModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    contact: "",
    company: "",
    message: ""
  });
  const [status, setStatus] = useState("idle"); // idle, loading, success, error

  const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbz1VarrXD8gBvouTxtaXlS1ez9IWx3qSZ7PH7RLpnDk4qu85FZoh1sg9_HpAbnZU_yijQ/exec";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const formBody = new URLSearchParams();
      Object.keys(formData).forEach(key => formBody.append(key, formData[key]));

      await fetch(SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: formBody.toString()
      });

      setStatus("success");
      setTimeout(() => {
        onClose();
        setStatus("idle");
        setFormData({ fullName: "", email: "", contact: "", company: "", message: "" });
      }, 2000);
    } catch (error) {
      console.error("Submission error details:", {
        message: error.message,
        url: SCRIPT_URL,
        stack: error.stack
      });
      setStatus("error");
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={onClose}
        >
          <motion.div
            className="modal-content"
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="modal-close-btn" onClick={onClose}>
              <FaTimes size={20} />
            </button>

            <div className="modal-header">
              <h2>Let's Talk</h2>
              <p>Tell us about your project and we'll get back to you shortly.</p>
            </div>

            {status === "success" ? (
              <motion.div
                className="success-message"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                style={{ textAlign: 'center', padding: '40px 0' }}
              >
                <FaCheckCircle size={50} color="#42cfc0" style={{ marginBottom: '20px' }} />
                <h3>Message Sent!</h3>
                <p>Thank you for reaching out. We will contact you soon.</p>
              </motion.div>
            ) : (
              <form className="contact-form modal-form" onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="fullName"
                  placeholder="Full Name"
                  className="pill-input"
                  required
                  value={formData.fullName}
                  onChange={handleChange}
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="pill-input"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
                <input
                  type="tel"
                  name="contact"
                  placeholder="Contact Number"
                  className="pill-input"
                  required
                  value={formData.contact}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  name="company"
                  placeholder="Company Name"
                  className="pill-input"
                  value={formData.company}
                  onChange={handleChange}
                />

                <textarea
                  name="message"
                  placeholder="How can we help you?"
                  className="rounded-textarea"
                  rows="4"
                  required
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>

                {status === "error" && (
                  <p style={{ color: '#ff4d4d', fontSize: '14px', marginBottom: '10px' }}>
                    Oops! Something went wrong. Please try again.
                  </p>
                )}

                <motion.button
                  type="submit"
                  className="submit-pill-btn modal-submit"
                  disabled={status === "loading"}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  {status === "loading" ? <FaSpinner className="spinner" /> : "Send message"}
                </motion.button>
              </form>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default ContactModal;
